import { API_STATUS } from 'core-lib/constants/network';

export const PRELOADING_STATES = [API_STATUS.default];
export const LOADING_STATES = [API_STATUS.in_progress];
export const EXTENDED_LOADING_STATES = [
  API_STATUS.default,
  API_STATUS.in_progress,
];
export const LOADED_STATES = [API_STATUS.success, API_STATUS.failure];

export const STORE_SESSION = {
  FUEL_INTRO: 'FUEL_INTRO',
};

export enum THEME {
  DARK = 'dark',
  LIGHT = 'light',
}
